import { MessageSquare } from "lucide-react";
import type { LunimarRealm } from "@/components/lunimar/lunimarRealms";

interface Props {
  realm?: LunimarRealm;
  /** 1-3 short prompts for a parent/child conversation. */
  prompts: string[];
  title?: string;
}

/**
 * Compact parent conversation-prompt card. Use in the recap so families
 * have concrete next-step talking points after the mission.
 */
const ParentInsightSummary = ({ realm, prompts, title = "Talk about it" }: Props) => {
  const accent = realm?.secondaryAccent ?? "262 78% 64%";
  if (!prompts.length) return null;
  return (
    <div
      className="rounded-xl border p-3 backdrop-blur-md sm:p-4"
      style={{
        borderColor: `hsl(${accent} / 0.3)`,
        background: `linear-gradient(135deg, hsl(${accent} / 0.08), hsl(228 45% 12% / 0.55))`,
      }}
    >
      <div className="flex items-center gap-2 text-[10px] font-mono uppercase tracking-widest"
           style={{ color: `hsl(${accent})` }}>
        <MessageSquare className="h-3 w-3" />
        {title}
      </div>
      <ul className="mt-2 space-y-1.5">
        {prompts.map((p, i) => (
          <li key={i} className="flex gap-2 text-[12px] leading-relaxed text-white/80">
            <span
              className="mt-1.5 inline-block h-1 w-1 shrink-0 rounded-full"
              style={{ background: `hsl(${accent})` }}
            />
            <span>{p}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ParentInsightSummary;